import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'
import { compose } from 'redux'

import { BookingsTableRowBase } from './BookingsTableRow'

import { isPartnerSelector } from 'reduxModules/selectors/UserSelectors'
import { busSelector, carriagePhonesSelector } from 'reduxModules/selectors/RouteSelectors'
import { bookingActions } from 'reduxModules/actions/BookingActions'
import { fromCityTypeByLabelSelector } from 'reduxModules/selectors/CitySelectors'
import { snackbarActions } from 'reduxModules/actions/SnackbarActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  bus: busSelector,
  isPartner: isPartnerSelector,
  carriagePhones: carriagePhonesSelector,
  fromCityTypeByLabel: fromCityTypeByLabelSelector,
})

const mapDispatchToProps = {
  setBooking: bookingActions.setBooking,
  showSnackbar: snackbarActions.showSnackbar,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const BookingsTableRow = enhance(BookingsTableRowBase)


// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsTableRow/index.js